import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const ICONS = {
	// complete: "",
	// cancel: "",
	// close: "",
	// delete: "",
	// clear: "",
	// success: "",
	// info: "",
	// warning: "",
	// error: "",
	next: "mdi-menu-right",
	prev: "mdi-menu-left",
	// checkboxOn: "",
	// checkboxOff: "",
	// checkboxIndeterminate: "",
	// delimiter: "",
	// sort: "",
	// expand: "",
	// menu: "",
	// subgroup: "",
	// dropdown: "",
	// radioOn: "",
	// radioOff: "",
	// edit: "",
}

const CUSTOM_ICONS = {
	search: "mdi-magnify"
}

const vuetify = new Vuetify({
	theme: {
		themes: {
			light: {
				primary: "#30ACD6",
				secondary: "#114673",
				// tertiary: "#999999",
			}
		}
	},
	icons: {
		iconfont: 'mdi',
		values: {
			...ICONS,
			...CUSTOM_ICONS
		}
	}
})

export default vuetify;